import React, { FC } from 'react';
import styled from '@emotion/styled';
import { ErrorInputIcon } from '../../icons/ErrorInputIcon';

const ValidationMessageStyle = styled.p`
  color: #ce1126;
  font-size: 12px;
  line-height: 1;
  margin: 0;
  margin-top: 10px;
  display: flex;
  align-items: center;
  & > svg {
    width: 16px;
    margin-right: 6px;
  }
`;
interface FieldValidationMessageProps {
  message: string;
}
export const FieldValidationMessage: FC<FieldValidationMessageProps> = ({ message }) => {
  return (
    <ValidationMessageStyle>
      <ErrorInputIcon />
      {message}
    </ValidationMessageStyle>
  );
};
